import { capitalize, cleanVar } from './utils';
export const cleanKeyword = (
  keyword: string,
  cleanIt: boolean = true,
  capitalizeIt: boolean = true,
  replaceAll: boolean = true
): string => {
  let result = keyword;
  if (cleanIt) {
    result = cleanVar(result);
  }
  if (capitalizeIt) {
    result = capitalize(result, replaceAll);
  }
  return result;
};

export const generateKeywordsList = (
  keywords: string | string[] | Set<string> | undefined,
  cleanIt: boolean = true,
  capitalizeIt: boolean = true,
  replaceAll: boolean = true
): string[] => {
  let keywordArray: string[] = [];
  if (!keywords) return [];
  if (typeof keywords === 'string') {
    keywordArray = keywords.replace(/#/g, ',').split(',').filter(Boolean);
  } else if (keywords instanceof Set) {
    keywordArray = Array.from(keywords);
  } else if (Array.isArray(keywords)) {
    keywordArray = keywords;
  }
  return keywordArray
    .map(keyword => cleanKeyword(keyword, cleanIt, capitalizeIt, replaceAll))
    .filter(Boolean);
};

export const convertKeywordsListToText = (
  keywords: string | string[] | Set<string> | undefined,
  hashSymbol: boolean | string = true,
  cleanIt: boolean = true,
  capitalizeIt: boolean = true,
  replaceAll: boolean = true
): string => {
  const keywordList = generateKeywordsList(keywords, cleanIt, capitalizeIt, replaceAll);
  if (keywordList.length === 0) return '';

  // If hashSymbol === true, prefix each keyword with '#'
  if (hashSymbol === true) {
    return keywordList.map(k => `#${k}`).join(' ');
  }

  // If hashSymbol is a string, use it as a separator (no prefix)
  if (typeof hashSymbol === 'string') {
    return keywordList.join(hashSymbol);
  }

  // hashSymbol === false -> comma-separated plain list
  return keywordList.join(',');
};


export const getMaxHashtags = (
  hashtags: string | string[] | Set<string>,
  charLimit: number | null = null,
  hashtagLimit: number | null = null,
  hashSymbol: boolean = true
): string => {
  const keywordList = generateKeywordsList(hashtags);
  if (keywordList.length === 0) return '';

  const prefix = hashSymbol ? '#' : '';
  const sep = hashSymbol ? ' ' : ',';
  const maxChars = charLimit ?? Number.MAX_SAFE_INTEGER;

  let output = '';
  let count = 0;

  for (const k of keywordList) {
    const tag = `${prefix}${k}`;
    const candidate = output ? `${output}${sep}${tag}` : tag;
    if (candidate.length <= maxChars) {
      output = candidate;
      count++;
      if (hashtagLimit && count >= hashtagLimit) break;
    } else {
      break;
    }
  }

  return output.trim();
};
